import { state } from './state'

export const store = [
  {
    workshop: 'Hawk Tyre Service Sdn Bhd',
    address: 'No. 90, Jalan Tampoi, 81200 Johor Bahru, Johor',
    state: state.JHR,
    contact: '07-335 8899',
    operatingHour: 'Mon-Sat : 8.30am - 5.30pm. Closed on Sun',
    lat: 1.5198597,
    lng: 103.7452539,
  },
  {
    workshop: 'Hawk Tyre Service Sdn Bhd - Suria',
    address: 'L1-1, Southern City, Hypermarket, Jalan Suria 18, 81100 Johor Bahru',
    state: state.JHR,
    contact: '07-333 8166',
    operatingHour: 'Mon-Sat : 9am - 6pm. Closed on Sun',
    lat: 1.5041156,
    lng: 103.7607339,
  },
  {
    workshop: 'Hawk Tyre Service Sdn Bhd - Shell',
    address: 'PTD 8923, Jalan Badik 1, Taman Sri Tebrau, 80050 Johor Bahru',
    state: state.JHR,
    contact: '07-334 6276',
    operatingHour: 'Mon-Sat : 9.00am - 6.00pm. Sun : 9.00am - 5.00pm',
    lat: 1.4863046,
    lng: 103.7688112,
  },
  {
    workshop: 'Hawk Tyre Service Sdn Bhd - Gaya',
    address: '2&2A, Jalan Gaya 24, Taman Gaya, 81100 Johor Bahru, Johor',
    state: state.JHR,
    contact: '07-861 9124',
    operatingHour: 'Mon-Sat : 9.00am - 6.00pm. Sun : 9.00am - 5.00pm. Closed on Tue',
    lat: 1.5674192,
    lng: 103.8005709,
  },
  {
    workshop: 'Hawk Tyre Service Sdn Bhd - Tebrau',
    address: '1&3, Jalan Perisai, Taman Sri Tebrau, 80050 Johor Bahru',
    state: state.JHR,
    contact: '07-331 4521',
    operatingHour: 'Mon-Sat : 9.00am - 6.00pm. Sun : 9.00am - 5.00pm',
    lat: 1.484312,
    lng: 103.765778,
  },
  {
    workshop: 'Hawk Tyre Service Sdn Bhd - Pelangi',
    address: '108, Jalan Sri Pelangi, Taman Pelangi, 80400 Johor Bahru',
    state: state.JHR,
    contact: '07-332 6850',
    operatingHour: 'Mon-Sat : 9.00am - 6.00pm. Sun : 9.00am - 5.00pm',
    lat: 1.4785817,
    lng: 103.776428,
  },
  {
    workshop: 'Hawk Tyre Service Sdn Bhd - Rinting',
    address: '56&58, Jalan Ara 1, Taman Rinting, 81750 Masai, Johor.',
    state: state.JHR,
    contact: '07-252 2686',
    operatingHour: 'Mon-Sat : 9.00am - 6.00pm. Closed on Sun',
    lat: 1.4928014,
    lng: 103.8749348,
  },
  {
    workshop: 'Hawk Tyre Service Sdn Bhd - Sentosa',
    address: '40, Jalan Sulam, Taman Sentosa, 80150 Johor Bahru.',
    state: state.JHR,
    contact: '07-333 4207',
    operatingHour: 'Mon-Sat : 9.00am - 6.00pm. Closed on Sun',
    lat: 1.49294,
    lng: 103.766964,
  },
  {
    workshop: 'Hawk Tyre Service Sdn Bhd - Aminah',
    address: '2&4, Jalan Laksamana 2, Taman Ungku Tun Aminah, 81300 Skudai, Johor',
    state: state.JHR,
    contact: '07-556 9131',
    operatingHour: 'Mon-Sat : 9.00am - 6.00pm. Closed on Sun',
    lat: 1.5269195,
    lng: 103.6685627,
  },
  {
    workshop: 'Hawk Tyre Service Sdn Bhd - Molek',
    address: '21, Jalan Molek 2/3, Taman Molek, 81100 Johor Bahru, Johor.',
    state: state.JHR,
    contact: '07-364 8572',
    operatingHour: 'Mon-Sat : 9.00am - 6.00pm. Closed on Sun',
    lat: 1.5292205,
    lng: 103.7926162,
  },
  {
    workshop: 'Hawk Tyre Service Sdn Bhd - Nusa Bestari',
    address: 'No.126, Jalan NB2 1/4, Taman Nusa Bestari 2,81300 Skudai, Johor.',
    state: state.JHR,
    contact: '07-520 1467',
    operatingHour: 'Mon-Sat : 9.00am - 6.00pm. Closed on Sun',
    lat: 1.500693,
    lng: 103.6544412,
  },
  {
    workshop: 'A & A Automobile Workshop (M) Sdn. Bhd.',
    address: '26,30,32,34 & 36, Jalan Permas 9/7, Permas Jaya, 81750 Masai, Johor',
    state: state.JHR,
    contact: '07-388 0363',
    operatingHour: 'Mon-Sat : 9am - 7.30pm.  Closed on Sun',
    lat: 1.4973351,
    lng: 103.8219172,
  },
  {
    workshop: 'Powerfull Car Service Centre',
    address: '177, Jalan Rawa, Taman Perling, 81200 Johor Bahru, Johor',
    state: state.JHR,
    contact: '07-241 1519',
    operatingHour: 'Tues -Sun : 10.30am - 6.00pm. Closed on Mon.',
    lat: 1.472662,
    lng: 103.66898,
  },
  {
    workshop: '99 STAR AUTO SERVICE',
    address:
      'No.Lot Ex3-B Bestari Bestmart PTD 154983, Jalan Danga Taman Nusa Bestari 2, 79150 Iskandar Puteri, Johor',
    state: state.JHR,
    contact: '011-2762 7119',
    operatingHour: 'Mon - Sun : 8.30am - 6.30pm.',
    lat: 1.4980216,
    lng: 103.6550668,
  },
  {
    workshop: 'Junction Car Wash & Auto Service',
    address: '15 Bawah, Jln Samsu Kg. Abdullah,  85000 Segamat, Johor',
    state: state.JHR,
    contact: '07 - 931 7765',
    operatingHour: 'Tues -Sun : 9am - 7.00pm. Closed on Mon.',
    lat: 2.5004394,
    lng: 102.8268176,
  },
  {
    workshop: 'Lai & Sons Workshop',
    address: 'A-1 Lorong Padang Lalang 9, Off Jalan Padang Lalang, 25250 Kuantan, Pahang.',
    state: state.PHG,
    contact: '09-515 9930',
    operatingHour: 'Mon-Sat : 9.30am - 6.30pm. Closed on Sun',
    lat: 3.813679112,
    lng: 103.3351559,
  },
  {
    workshop: 'Soon Heng Huat Tayar & Bateri',
    address:
      'PTB 12848, No.13, Jalan Delima 1/1,\nPusat Perdagangan Pontian,\nBandar 2,\n82000 Pontian, Johor',
    state: state.JHR,
    contact: '07-686 3461',
    operatingHour: 'Mon-Sat : 9.30am - 7pm. Sun : 9.30am - 5pm',
    lat: 1.479141301,
    lng: 103.3907042,
  },
  {
    workshop: 'Teng Heng Auto Service',
    address: 'PT 3046, HS(D) 27536,\nJalan Bukit Pasir\n83000 Batu Pahat, Johor',
    state: state.JHR,
    contact: '07-434 4588',
    operatingHour: 'Mon-Sat : 9am - 6pm. Closed on Sun',
    lat: 1.88484378,
    lng: 102.9349265,
  },
  {
    workshop: 'Bao Liang Auto Car Care Centre Sdn Bhd',
    address: 'No. 1, Jalan Indah 1/1\nTaman Bukit Indah,\n81200 Johor Bahru, Johor',
    state: state.JHR,
    contact: '07-244 4838',
    operatingHour: 'Mon-Sun : 10am - 7.30pm',
    lat: 1.487836404,
    lng: 103.6626968,
  },
  {
    workshop: 'Chye Huat Tyre Service Centre',
    address: '72, Jalan Badik 20, \nTaman Puteri Wangsa,\n81800 Ulu Tiram, Johor',
    state: state.JHR,
    contact: '07-867 2800',
    operatingHour: 'Mon-Sun : 9am - 7pm',
    lat: 1.580007493,
    lng: 103.8113869,
  },
  {
    workshop: 'CK Car Auto Services & Tyre Centre Sdn Bhd',
    address: 'No. 84, Jalan Perjiranan 2,\nBandar Dato Onn,\n81100 Johor Bahru, Johor',
    state: state.JHR,
    contact: '016 - 712 3534',
    operatingHour: 'Mon-Sun : 9.30am - 8.30pm',
    lat: 1.558465998,
    lng: 103.7390652,
  },
  {
    workshop: 'Nusa Jaya Tyres & Batteries Sdn Bhd',
    address: '38, Jalan Perdagangan Damai,\nTaman Nusa Damai,\n81700 Pasir Gudang, Johor',
    state: state.JHR,
    contact: '013-779 2888',
    operatingHour: 'Mon- Sat :10am-7pm. Closed on Sun',
    lat: 1.4881314,
    lng: 103.9152199,
  },
  {
    workshop: 'Pusat Servis Kereta Dan Tayar Han Son',
    address: 'No. 47-G, Jalan Permas 11/1C,\nBandar Baru Permas Jaya,\n81750 Masai, Johor',
    state: state.JHR,
    contact: '017-891 4816',
    operatingHour: 'Mon- Sat : 9am-7pm. Closed on Sun',
    lat: 1.496436235,
    lng: 103.8124146,
  },
  {
    workshop: 'Seng Lee Auto Service',
    address: '90, Jalan Suria Satu\nTaman Malim Jaya\n75250 Malim,',
    state: state.MLK,
    contact: '06-335 7533',
    operatingHour: 'Mon- Sat : 9am-6pm. Closed on Sun',
    lat: 2.23504079,
    lng: 102.2353578,
  },
  {
    workshop: 'Speed One Tyre Service Sdn Bhd',
    address: '29, Jalan MJ 32\nTaman Merdeka Jaya\n75350 Batu Berendam, Melaka',
    state: state.MLK,
    contact: '06-319 1121',
    operatingHour: 'Mon- Sat : 9.30am- 6pm. Sun: 9.30am - 5.30pm. Closed on Tues.',
    lat: 2.272294937,
    lng: 102.2464095,
  },
  {
    workshop: 'Maswheel Service Sdn Bhd',
    address: '185, Jalan NB2/2,\nTaman Nusa Bestari 2,\n81300 Skudai, Johor',
    state: state.JHR,
    contact: '07-557 5115',
    operatingHour: 'Mon- Sun : 9.30am-7pm. Closed on Tues.',
    lat: 1.495865505,
    lng: 103.6545942,
  },
  {
    workshop: 'Pusat Servis Kereta Li Sern',
    address: '22, Jalan Hang Tuah 4\nTaman Skudai Baru\n81300 Skudai, Johor',
    state: state.JHR,
    contact: '07-554 8415',
    operatingHour: 'Mon- Fri : 9am-6.30pm. Closed on Sat & Sun',
    lat: 1.525681849,
    lng: 103.6582418,
  },
  {
    workshop: 'Pusat Tayar Heng Long - Bukit Indah',
    address: '45, Jalan Indah 16/11\nTaman Bukit Indah\n81200 Johor Bahru, Johor',
    state: state.JHR,
    contact: '07-232 8993',
    operatingHour: 'Mon- Sun : 10am-6pm. Closed on Thurs.',
    lat: 1.47970551,
    lng: 103.6646235,
  },
  {
    workshop: 'Dek Huat Tyre Battery Sdn Bhd',
    address: '118, Jalan Laksamana Cheng Ho, \n75000 Semabok,',
    state: state.MLK,
    contact: '06-282 3803',
    operatingHour: 'Mon- Sat : 9am-7pm. Closed on Sun',
    lat: 2.194857584,
    lng: 102.2599672,
  },
  {
    workshop: 'Power Box Auto',
    address: '50, Jalan Maju Timur\nTaman Maju\n83000 Batu Pahat, Johor',
    state: state.JHR,
    contact: '016-7382677',
    operatingHour: 'Mon-Sat : 10am - 6pm. Closed on Sun',
    lat: 1.869089293,
    lng: 102.9441265,
  },
  {
    workshop: 'Bengkel Seng Yong Seng',
    address: '1959, Jalan Kukup, Batu 39 1/4\nKampung Rimba Terjun\n82000 Pontian, Johor',
    state: state.JHR,
    contact: '07-687 0461',
    operatingHour: 'Mon-Sat : 10am - 6pm. Closed on Sun',
    lat: 1.4470069,
    lng: 103.4086624,
  },
  {
    workshop: 'City Car Service Centre',
    address: '45-5, Jalan Syed Abdullah, \nKampung Merdeka\n83000 Batu Pahat, Johor',
    state: state.JHR,
    contact: '013-7231800',
    operatingHour: 'Mon-Sat : 10am - 6pm. Closed on Sun',
    lat: 1.853277647,
    lng: 102.9338964,
  },
  {
    workshop: 'KS Brothers Tyres & Auto Services Centre',
    address: 'No 282 Bwh, Jalan Mersing BT 2, 86000 Kluang, Johor',
    state: state.JHR,
    contact: '017-718 8429',
    operatingHour: 'Tues- Sun : 9am-7pm. Mon: 9am - 5pm',
    lat: 2.035259876,
    lng: 103.3305105,
  },
  {
    workshop: 'Ming Keong Auto Workshop',
    address: '5, Jalan Perindustrian 3, Kawasan Perindustrian Ringan, 86200 Simpang Renggam, Johor',
    state: state.JHR,
    contact: '07-354 6323',
    operatingHour: 'Mon-Sat : 9am - 6pm. Closed on Sun',
    lat: 1.546023599,
    lng: 103.7728561,
  },
  {
    workshop: 'Sin Soon Lee Auto Service Centre',
    address: '10, Jalan Kampung Paya, Kluang Baru, 86000 Kluang, Johor',
    state: state.JHR,
    contact: '07-774 4460',
    operatingHour: 'Mon-Sat : 10am - 6pm. Closed on Sun',
    lat: 2.04045297,
    lng: 103.3341894,
  },
  {
    workshop: 'A Teck Auto Sdn. Bhd.',
    address: '36, 36-01, 36-02,\nJalan Kota 1/4,\nTaman Cahaya Kota Putri,\n81750 Masai, Johor',
    state: state.JHR,
    contact: '016-714 9696',
    operatingHour: 'Tue - Sat : 10am - 7pm. Sun : 10am - 5pm . Closed on Mon',
    lat: 1.4911317,
    lng: 103.843061,
  },
  {
    workshop: 'AMG Car Automobile Sdn. Bhd.',
    address: 'No. 20, Jalan Mutiara Emas 4/19,\nTaman Mount Austin,\n81100 Johor Bahru, Johor',
    state: state.JHR,
    contact: '016-260 6887',
    operatingHour: 'Mon - Sat : 9am - 6pm . Closed on Sunday',
    lat: 1.553097127,
    lng: 103.7784527,
  },
  {
    workshop: 'Auto Champion Star',
    address: '2, Jalan Titiwangsa 4\nTaman Tampoi Indah\n81200 Johor Bahru, Johor',
    state: state.JHR,
    contact: '012-711 3758',
    operatingHour: 'Mon - Fri : 9am - 6pm . Sat : 9am - 5pm . Closed on Sunday',
    lat: 1.506295228,
    lng: 103.6890439,
  },
  {
    workshop: 'Borneo Star Automobile Sdn Bhd',
    address: '113, Jalan Seroja 39\nTaman Johor Jaya\n\n81100 Johor Bahru, Johor',
    state: state.JHR,
    contact: '07-3585855',
    operatingHour: 'Mon - Sat : 9am - 6pm . Closed on Sunday',
    lat: 1.533783523,
    lng: 103.8037902,
  },
  {
    workshop: 'BW Advanced Tech Car Service',
    address: '30, Jalan Rawa 2, Taman Desa Cemerlang, \n81800 Ulu Tiram, Johor',
    state: state.JHR,
    contact: '019-6279319',
    operatingHour: 'Mon - Sat : 11am -9pm . Closed on Sunday',
    lat: 1.561716515,
    lng: 103.8068306,
  },
  {
    workshop: 'Dream Garage (M) Sdn Bhd',
    address: '22, Jalan Mutiara Emas 5/1,\nTaman Mount Austin,\n81100 Johor Bahru, Johor',
    state: state.JHR,
    contact: '012-7078080',
    operatingHour: 'Mon - Sat : 9.30am -7.30pm. Closed on Sunday',
    lat: 1.550856382,
    lng: 103.7795561,
  },
  {
    workshop: 'EKS Motorsport',
    address: '3, Jalan Rosemerah 2/13\nTaman Johor Jaya\n81100 Johor Bahru, Johor',
    state: state.JHR,
    contact: '012-7720839',
    operatingHour: '',
    lat: 1.534272773,
    lng: 103.7955785,
  },
  {
    workshop: 'Elco Autoworld Sdn. Bhd.',
    address:
      '44,Jalan Sme 3,\nKawasan Perindustrian SME,\nBandar Indahpura,\n81000 Kulai Jaya, Johor',
    state: state.JHR,
    contact: '07-6600188',
    operatingHour: 'Mon - Sat : 9.00am - 6pm. Closed Sunday',
    lat: 1.643130914,
    lng: 103.6079459,
  },
  {
    workshop: 'First Performance Service Centre',
    address: '395 & 395A, Jalan Kenanga 29/10\nTaman Indahpura\n81000 Kulai Jaya, Johor',
    state: state.JHR,
    contact: '013-3924900',
    operatingHour: 'Mon - Sat : 9.00am - 6pm. Closed Sunday',
    lat: 1.64253056,
    lng: 103.6167816,
  },
  {
    workshop: 'Foong Auto Service',
    address: '35, Jalan Beladau 5\nTaman Puteri Wangsa\n81800 Ulu Tiram, Johor',
    state: state.JHR,
    contact: '016-7822686',
    operatingHour: 'Mon - Sat : 9.00am - 7pm.  Sun 10am-3pm',
    lat: 1.642685088,
    lng: 103.6173102,
  },
  {
    workshop: 'GAT Services Sdn Bhd',
    address:
      'Lot 8959 & 8957K,\nKawasan Perindustrian Gong Badak,\n21300 Kuala Terengganu, Terengganu',
    state: state.TRG,
    contact: '019-9391284',
    operatingHour: 'Monday - Sun : 9.00am-  5.30pm. Closed on Fri',
    lat: 5.391599622,
    lng: 103.0777622,
  },
  {
    workshop: 'HL Carcare Centre Sdn. Bhd.',
    address: '73,Jalan Indah 16/12,\nTaman Bukit Indah,\n81200 Johor Bahru, Johor',
    state: state.JHR,
    contact: '07-2396343',
    operatingHour: 'Mon - Sat : 10am -7.30pm . Sun : 10am- 7pm. Closed on Tue',
    lat: 1.478323925,
    lng: 103.6657027,
  },
  {
    workshop: 'Lau Sincere Autowagon Services Sdn Bhd',
    address: '1, Jalan AnggeriK 3/1, \nTaman Anggerik,\n81200 Johor Bahru, Johor',
    state: state.JHR,
    contact: '016-7711231',
    operatingHour: 'Mon - Sat : 9am -7pm . Sun 9am-4pm',
    lat: 1.538763991,
    lng: 103.69194,
  },
  {
    workshop: 'Mee Auto Tyres & Battery Services',
    address: '2 & 4, Jalan Dian 8, \nTaman Munsyi Ibrahim,\n81200 Johor Bahru, Johor',
    state: state.JHR,
    contact: '07-2383953',
    operatingHour: 'Mon - Sat : 9.30am-6pm. Closed on Sun',
    lat: 1.514940699,
    lng: 103.6892803,
  },
  {
    workshop: 'Rainbow Green Tech Sdn Bhd',
    address: 'No.1A, Jalan Senyum\nJalan Senyum,\n80300 Johor Bahru, Johor',
    state: state.JHR,
    contact: '07-2211935',
    operatingHour: '',
    lat: 1.479041064,
    lng: 103.7590267,
  },
  {
    workshop: 'Sin Chu Hin Sdn Bhd',
    address: '10,11,12, JalanChengal,\nTaman Batu Pahat\n83000 Batu Pahat, Johor',
    state: state.JHR,
    contact: '07-4312682',
    operatingHour: 'Mon - Sat 9.00am- 6pm. Closed on Sun',
    lat: 1.863278932,
    lng: 102.9070222,
  },
  {
    workshop: 'Syarikat Deksen Trading Sdn Bhd',
    address: '8F, Jalan Larkin\n80200 Johor Bahru, Johor',
    state: state.JHR,
    contact: '07-2236028',
    operatingHour: '',
    lat: 1.500630227,
    lng: 103.7490347,
  },
  {
    workshop: 'TH Auto Services Centre',
    address: 'AI, Jalan Padang Lalang 8\n25050 Kuantan, Pahang',
    state: state.PHG,
    contact: '019-9507929',
    operatingHour: '',
    lat: 3.812375712,
    lng: 103.3359019,
  },
  {
    workshop: 'Union Tyre And Service Sdn Bhd',
    address: '173, Jalan Keris 1,\nTaman Sri Tebrau,\n80050 Johor Bahru, Johor',
    state: state.JHR,
    contact: '012-7843535',
    operatingHour: 'Mon-Sat : 9am-6.30pm. Closed on Sun',
    lat: 1.490005704,
    lng: 103.7675767,
  },
  {
    workshop: 'WMJ Autoservice',
    address: 'Lot 3135 Kg Kutan,\n16250 Wakaf Baru, Kelantan',
    state: 'Kelantan',
    contact: '014-7441414',
    operatingHour: 'Mon, Fri , Sun : 12am - 6am . Mon, Tue, Wed : 9am -12am',
    lat: 6.094719258,
    lng: 102.208465,
  },
  {
    workshop: 'Venus Tyres Car Service Enterprise',
    address: 'No 9 Jalan Nadi 4,\nSenadi Square,\n79250 NusaJaya, Johor,',
    state: state.JHR,
    contact: '019-6646694',
    operatingHour: 'Mon-Sat: 9am - 7pm . Closed on Sunday',
    lat: 1.439795633,
    lng: 103.6323436,
  },
  {
    workshop: 'Zeuss Performance Auto',
    address: "148, Jalan Sentral 28, Taman Nusa Sentral, 79100 Iskandar Puteri, Johor Darul Ta'zim",
    state: state.JHR,
    contact: '012-9453980',
    operatingHour: 'Mon-Sat : 10am-6.30pm . Sun 11am- 6.30pm',
    lat: 1.473929503,
    lng: 103.615718,
  },
  {
    workshop: 'Stuttgart Auto Meister Service Center',
    address: 'No. 69, Jalan Perdagangan 3,\nTaman Universiti,\n81300 Skudai, Johor',
    state: state.JHR,
    contact: '012-5012674',
    operatingHour: 'Mon-Fri : 9am- 6pm. Sat 9.30am 5pm . Closed on Sun',
    lat: 1.543808872,
    lng: 103.6252459,
  },
  {
    workshop: 'Merz Auto Service Centre (M) Sdn Bhd',
    address:
      'No. 23, 25 & 27, Jalan Damai Utama,\nTaman Industries Damai Plus, Off Jalan Kluang,\n83000 Batu Pahat, Johor,',
    state: state.JHR,
    contact: '012-7279833',
    operatingHour: 'Mon-Sat : 9.30am-6pm. Closed on Sunday',
    lat: 1.861587607,
    lng: 102.9648406,
  },
  {
    workshop: 'Avantgarde Motorworks Garage Sdn. Bhd.',
    address: 'No. A45, A46 & A47, Lorong 11/1A, Tamn Bandar Baru,\n08000 Sungai Petani, Kedah,',
    state: state.KDH,
    contact: '04-4400356',
    operatingHour: 'Mon-Sat : 10am-7pm. Closed on Sunday',
    lat: 5.828340935,
    lng: 100.4616621,
  },
  {
    workshop: 'Eng Lean Auto Repair',
    address: '16-18, Lorong Seratus Tahun,\n10400 George Town, Penang,',
    state: state.PNG,
    contact: '',
    operatingHour: '',
    lat: 5.415185027934952,
    lng: 100.32313586563863,
  },
  {
    workshop: 'German Auto Garage Enterprise',
    address: 'No.68C, Lorong Bendaharah Ujung Jalan Langgar,\n05300 Alor Setar, Kedah,',
    state: state.KDH,
    contact: '019-400 1790',
    operatingHour: 'Open 24 hours. Closed on Friday',
    lat: 6.158718337,
    lng: 100.361933,
  },
  {
    workshop: 'Gsa Auto Service',
    address: 'G 1611, Jalan Kebun Sirih,\n14000 Bukit Mertajam, Penang,',
    state: state.PNG,
    contact: '016-551 4374',
    operatingHour: 'Mon-Sat : 9am- 6pm.Closed on Sun',
    lat: 5.539445682,
    lng: 100.3820801,
  },
  {
    workshop: 'Hitech Autocare Sdn Bhd',
    address: '88 Jalan Pahang\n10400 George Town, Penang,',
    state: state.PNG,
    contact: '012-9368799',
    operatingHour: 'Mon-Sat: 9am - 6pm . Closed on Sunday',
    lat: 5.412843243,
    lng: 100.3216538,
  },
  {
    workshop: 'Hong Seng Auto Tyre',
    address:
      '11 & 11-A (Ground Floor) Jln Helang Desa  Permai Indah Sungai Dua,\n11700 Gelugor, Penang,',
    state: state.PNG,
    contact: '016-4237948',
    operatingHour: 'Mon-Sat: 10am - 7pm . Closed on Sunday',
    lat: 5.350075512,
    lng: 100.2992041,
  },
  {
    workshop: 'Jtm Auto Services Sdn Bhd',
    address: 'Lot No.6643, Jalan Tok Kangar, Mk13, Juru,\n14000 Bukit Mertajam, Penang,',
    state: state.PNG,
    contact: '010-2026868',
    operatingHour: 'Mon-Sat: 9am - 6pm . Closed on Sunday',
    lat: 5.324919228,
    lng: 100.434623,
  },
  {
    workshop: 'Lai Auto Service Centre',
    address: 'No 2, Jalan Sinari 1, Taman Suria,\n14300 Nibong Tebal, Penang,',
    state: state.PNG,
    contact: '016-542 6035',
    operatingHour: '',
    lat: 5.143292365,
    lng: 100.4698991,
  },
  {
    workshop: 'Mastery Ace Sdn Bhd',
    address: '2036-A, Jln Rozhan Alma\n14000 Bukit Mertajam, Penang,',
    state: state.PNG,
    contact: '012-508 0199',
    operatingHour: 'Mon,tue,fri ,sat : 9.00am-5pm. Wed-Thu 9.30am-7pm. Closed on Sun',
    lat: 5.340803822,
    lng: 100.485289,
  },
  {
    workshop: 'Maxiria Enterprise Sdn Bhd',
    address: '132,Lrg 3,Taman Ria,\n08000 Sungai Petani, Kedah,',
    state: state.KDH,
    contact: '04-4413346',
    operatingHour: 'Mon- Sun : 9am-6pm',
    lat: 5.663091124,
    lng: 100.5051745,
  },
  {
    workshop: 'Mng Quality Auto Service Sdn Bhd',
    address: '93,Persiaran Seksyen 4/7,Bandar Putra Pertam,\n13200 Kepala Batas, Penang,',
    state: state.PNG,
    contact: '012- 9668313',
    operatingHour: 'Mon- Sun : 8.30am-6pm. Closed on Fri .',
    lat: 5.519862393,
    lng: 100.4793812,
  },
  {
    workshop: 'Padang Serai Tyres Sdn Bhd',
    address: 'No 5730,Jalan Mahsuri 10/B,Taman Mahsuri,\n09400 Padang Serai,',
    state: state.KDH,
    contact: '012-4113618',
    operatingHour: 'Mon- Sun : 9am-7pm',
    lat: 5.515446031,
    lng: 100.5426031,
  },
  {
    workshop: 'Pusat Tayar & Servis Kereta Eng Wah',
    address: 'No 725, Mk2, Jalan Samagagah Permatang Pauh\n13500 Prai, Penang,',
    state: state.PNG,
    contact: '04-3972612',
    operatingHour: 'Mon-Sat: 9.30am - 7pm . Sun 10am-7pm',
    lat: 5.412144239,
    lng: 100.4130862,
  },
  {
    workshop: 'Soon Lie Car Service',
    address: '461, Jalan Baru Batu Maung,\n11960 Bayan Lepas, Penang,',
    state: state.PNG,
    contact: '012-4271873',
    operatingHour: 'Mon- Sat : 9am-6pm. Closed on Sun',
    lat: 5.297904823,
    lng: 100.2809715,
  },
  {
    workshop: 'Spgc Enterprise Sdn Bhd',
    address: 'No.1, Jalan Temusu,Taman Temusu,\n08000 Sungai Petani, Kedah,',
    state: state.KDH,
    contact: '016-5207618',
    operatingHour: 'Mon- Sun : 9am-7pm',
    lat: 5.602401957,
    lng: 100.4720686,
  },
  {
    workshop: 'Steelmax Tyre Sdn Bhd',
    address: 'No 2,Jalan Industri Alma,Kawasan Industri Alma,\n14000 Bukit Mertajam, Penang,',
    state: state.PNG,
    contact: '012-4385089',
    operatingHour: 'Mon- Sat : 9am-6pm. Sun : 9.30am-3.30pm',
    lat: 5.328405862,
    lng: 100.4794484,
  },
  {
    workshop: 'Syarikat Tatt Eng Tayar Dan Bateri',
    address: '416-422,Jalan Jelutong,\n11600 Jelutong, Penang,',
    state: state.PNG,
    contact: '04-2826306',
    operatingHour: 'Mon- Sat : 9.15am-5.45pm. Closed on Sun',
    lat: 5.393001084,
    lng: 100.314872,
  },
  {
    workshop: 'Tasek Tyres Sdn. Bhd.',
    address:
      'No.78,Jalan Tasek Mutiara 6,Pusat Komersial Bandar Tasek Mutiara,Persaiaran Mutiara 1,\n14120 Simpang Ampat, Penang,',
    state: state.PNG,
    contact: '012-2341981',
    operatingHour: 'Mon- Sun : 9.30am-7.30pm',
    lat: 5.275177346,
    lng: 100.4927024,
  },
  {
    workshop: 'Western Motor Sports Sdn Bhd',
    address: 'Lot 7093,Jalan Tok Kangar, Auto-Link Juru,\n14100 Simpang Ampat, Penang,',
    state: state.PNG,
    contact: '04-5020298',
    operatingHour: 'Mon-Sat: 9.00am - 6pm. Sat 9am-2pm. Closed on Sun',
    lat: 5.322664229,
    lng: 100.4357875,
  },
  {
    workshop: 'You Ge Car Repair',
    address: 'Lot 348, Jalan Sungai Batu,\n34900 Pantai Remis, Perak,',
    state: state.PRK,
    contact: '05-677 4608',
    operatingHour: 'Mon- Sat : 9am-6pm. Closed on Sun',
    lat: 4.690873662,
    lng: 100.6582259,
  },
  {
    workshop: 'Ipoh Jaya Auto Accessories',
    address: 'No.02, Medan Stesen 19/1,Station 18,\n31650 Ipoh, Perak,',
    state: state.PRK,
    contact: '',
    operatingHour: 'Mon- Sat : 9am-6pm. Closed on Sun',
    lat: 4.542593242,
    lng: 101.0674088,
  },
  {
    workshop: 'Kedai Tayar Lian Hup Soon',
    address: 'Pt 33212 & 33213, Jalan Raja Omar,\n32000 Sitiawan, Perak,',
    state: state.PRK,
    contact: '05-6927581',
    operatingHour: 'Mon- Sat : 8am-7pm. Closed on Sun',
    lat: 4.206441294,
    lng: 100.6982559,
  },
  {
    workshop: 'Pusat Aksesori Kereta Leong',
    address: '125, Hala Sepakat 15A,Taman Pinggir Rapat Perdana,\n31350 Ipoh,',
    state: state.PRK,
    contact: '05-3137188',
    operatingHour: 'Mon- Sat : 9.30am-6.30pm. Closed on Sun',
    lat: 4.568964632,
    lng: 101.1356152,
  },
  {
    workshop: 'Pusat Auto Hing Chok Hock',
    address: '37 & 38 ,Taman Mas, Kg Koh,\nSitiawan,',
    state: state.PRK,
    contact: '01-65588001',
    operatingHour: 'Mon- Sat : 9am-7pm. Closed on Sun',
    lat: 4.195327399,
    lng: 100.706482,
  },
  {
    workshop: 'Yf Tyre Service Centre',
    address: 'No 245, Jalan Bercham, Taman Desa Kencana\n31400 Ipoh, Perak,',
    state: state.PRK,
    contact: '012-5589374',
    operatingHour: 'Mon- Sat : 9.30am-7pm. Closed on Sun',
    lat: 4.629469697,
    lng: 101.1270409,
  },
  {
    workshop: 'Yong Shun Car Service',
    address: '112, Pekeliling Dataran Kledang, Industri Chandan Raya,\n31450 Menglembu, Perak,',
    state: state.PRK,
    contact: '016-5063775',
    operatingHour: '',
    lat: 4.578780804,
    lng: 101.0384207,
  },
  {
    workshop: 'Dr. Tech Auto Care Sdn Bhd',
    address: 'No.8 & 9, Tingkat Bawah,Taman Kristal,\n05150 Alor Setar, Kedah,',
    state: state.KDH,
    contact: '04-7302300',
    operatingHour: 'Mon- Sun : 9.00am-6.00pm. Closed on Fri',
    lat: 6.139223311,
    lng: 100.3577787,
  },
  {
    workshop: 'Eurowagen Services (Pg) Sdn Bhd',
    address:
      'No.80, Jalan Star Avenue, Pusat Perniagaan Star Avenue,\n14100 Simpang Ampat, Penang,',
    state: state.PNG,
    contact: '017-5600041',
    operatingHour: 'Mon- Fri : 9am-6.30pm. Sat : 9.30am-4pm. Closed on Sun',
    lat: 5.263774152,
    lng: 100.4786107,
  },
  {
    workshop: 'Yc Car Service Centre',
    address: '94 Lorong Kerjasama 1, Bukit Tengah,\n14000 Bukit Mertajam, Penang,',
    state: state.PNG,
    contact: '012-4366927',
    operatingHour: 'Mon- Sat : 9.30am-7.30pm. Sunday 11am -6pm',
    lat: 5.359069806,
    lng: 100.4270464,
  },
  {
    workshop: 'Chen Auto Car Service',
    address: 'No 330 Mk15 Jln Tasek Kampung Valdor\n14200 Sungai Bakap, Penang,',
    state: state.PNG,
    contact: '012-4317658',
    operatingHour: 'Mon- Sat : 9.30am-7pm. Closed on Sun',
    lat: 5.238572103,
    lng: 100.4914322,
  },
  {
    workshop: 'Js Tyre & Service Center',
    address: '2298, Jalan Bukit Minyak,Taman Permai Jaya,\n14000 Bukit Mertajam, Penang,',
    state: state.PNG,
    contact: '016-4214381',
    operatingHour: 'Mon- Sat : 9.00am-6.30pm. Sunday 9.00am -11.30pm',
    lat: 5.336226688,
    lng: 100.463537,
  },
  {
    workshop: 'Tat Kuang Car Service (M) Sdn. Bhd.',
    address:
      'Lot 1853, Jalan Paya Terubung Sungai Ara,\nJalan Kampung, Relau\n11900 Bayan Lepas, Penang,',
    state: state.PNG,
    contact: '017-4282396',
    operatingHour: 'Mon- Sat : 9.00am-6.30pm. Closed on Sun',
    lat: 5.339077106,
    lng: 100.2760375,
  },
  {
    workshop: 'M3 Simemn Service Centre',
    address: 'No 4857, Jalan Siram,\n12100 Butterworth, Penang,',
    state: state.PNG,
    contact: '012-4499144',
    operatingHour: '',
    lat: 5.408648067,
    lng: 100.3775336,
  },
  {
    workshop: 'Great Union Auto Service',
    address: '44, Jalan Utara 4, (Fasa 2A),Kawasan Perusahaan Merong 2A,\n05150 Alor Setar, Kedah,',
    state: state.KDH,
    contact: '04-7336139',
    operatingHour: 'Mon- Sun : 9.00am-6.00pm. Closed on Fri',
    lat: 6.120786412,
    lng: 100.3412987,
  },
  {
    workshop: 'Pad Pro Garage',
    address: 'No.8, Lorong Perniagaan 2,Pusat Perniagaan Sungai Dua,\nButterworth,',
    state: state.PNG,
    contact: '019-2022255',
    operatingHour: 'Mon- Sat : 9.00am-6.30pm. Closed on Sun',
    lat: 5.444877403,
    lng: 100.4308249,
  },
  {
    workshop: 'Tat Kuang Tyre & Car Service (M) Sdn. Bhd.',
    address:
      'No. 6, Jalan Sungai Tiram 3,\nTaman Tunas Damai Sungai Tiram,\n11900 Bayan Lepas, Penang,',
    state: state.PNG,
    contact: '017-4162048',
    operatingHour: 'Mon- Sun : 9.00am-6.30pm.  Sun 9am-4pm',
    lat: 5.301657068,
    lng: 100.2710886,
  },
  {
    workshop: 'My Spirit Service Sdn Bhd',
    address: 'No 201 & 203, Jalan Impian Emas 22,\nTaman Impian Emas Skudai,\n81300 Skudai, Johor,',
    state: state.JHR,
    contact: '07-5584115',
    operatingHour: 'Mon- Sat : 9.00am-6.00pm. Closed on Sun',
    lat: 1.541202273,
    lng: 103.6678354,
  },
  {
    workshop: 'Akif Automobile',
    address: 'No.2968C, Jalan Sultanah,\n05350 Alor Setar, Kedah,',
    state: state.KDH,
    contact: '011-10734308',
    operatingHour: 'Mon- Sun : 9.00am-6.00pm. Closed on Fri',
    lat: 6.142832168,
    lng: 100.3829431,
  },
  {
    workshop: 'Chang Cheng Auto Services Sdn Bhd',
    address: '219A-B, Jalan Sungai Pinang,\n11000 Balik Pulau, Penang,',
    state: state.PNG,
    contact: '04-866 8094',
    operatingHour: 'Mon- Sat : 10.30am-7.30pm. Closed on Sun',
    lat: 5.352234064309952,
    lng: 100.23097611534175,
  },
]
